import React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils';

const badgeVariants = cva(
  'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[0.7rem] font-medium leading-none font-mono uppercase tracking-wide transition-colors',
  {
    variants: {
      variant: {
        default: 'border-border-strong bg-white/[0.03] text-muted',
        outline: 'border-border-strong bg-transparent text-muted',
        primary: 'border-primary/40 bg-primary/10 text-primary-light',
        success: 'border-accent-green/40 bg-accent-green/10 text-accent-green',
        warning: 'border-accent-amber/40 bg-accent-amber/10 text-accent-amber',
        peach: 'border-accent-peach/40 bg-accent-peach/10 text-accent-peach',
        tag: 'border-accent-lavender/30 bg-accent-lavender/10 text-accent-lavender',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

const Badge = ({ className, variant, dot = false, children, ...props }) => (
  <span className={cn(badgeVariants({ variant }), className)} {...props}>
    {dot && <span className="h-1.5 w-1.5 rounded-full bg-current" />}
    {children}
  </span>
);

export { Badge, badgeVariants };
